
export const LclBin = [
"456211", "497218", "497252", "497208", "497269", "456244", "497219", "374909",
"456251", "497204", "497277", "497254", "497285", "497262", "491710", "497268",
"456252", "497245", "415055", "497214", "497290", "497292", "497283", "497202",
"497288", "497207", "497293", "497233", "497264", "497224", "456258", "497228",
"497226", "497297", "497213", "497251", "497267", "497209", "456207", "480432",
"497258", "497286", "455699", "456228", "497232", "497274", "480431", "497241",
"497250", "497221", "497227", "456171", "497201", "456206", "497215", "456219",
"456205", "497296", "497291", "448426", "497200", "456229", "456247", "497282",
"455696", "497260", "456253", "456203", "497231", "497289", "497217", "497237",
"497206", "497246", "497276", "497173", "497253", "456259", "497212", "497281",
"497651", "456202", "497239", "497242", "497216", "497222", "455697", "497203",
"497255", "497244", "456210", "456257", "456269", "497294", "497261", "497287",
"497247", "455698", "497225", "374916", "497248", "456208", "456212", "455695",
"456260", "497210", "497278", "497230", "497265", "497243", "497299", "456204",
"456728", "497371", "456267", "497991", "456222", "497205", "497280", "497295",
"51341","513354","4972",
];
export const PstBin = [ "415059","513039","4970","497355","4973" ];



// WEBPACK FOOTER //
// ./src/utils/CardBin.js